import { createContext } from 'react';
import type { BrandInsightsInstanceContext } from '@trinity/chat';

export type PendingContextValue = {
  pendingContext: BrandInsightsInstanceContext.ItemWithMetadata | null;
  setPendingContext: (context: BrandInsightsInstanceContext.ItemWithMetadata | null) => void;
};

/**
 * A Context-dropdown pick awaiting a subject before it commits (see `FilterPane`'s
 * `ContextFilterController`/`ProjectController`). Exposed via context so other UI
 * under the same provider can observe it too.
 */
export const PendingContextContext = createContext<PendingContextValue | null>(null);
